/**************************************************************************************************************************************************
*   MODULE NAME     :  UserApi
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  26-02-2021
*   DESCRIPTION     :  User API class
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import axios from "axios";
import config from "../config.json";
import ApiBase from "./ApiBase";

class UserApi {

  static addAbstractDetails = async payload => {
    try {
      const response = await axios.post(
        config.Backend_URL + "abstract/add",
        payload
      );
      return response;
    } catch (error) {
      return error;
    }
  };
  
  static createUser = async (userDetails) => {
    let payload = {action: "createNewUser", userDetails};
    const response = await ApiBase.post(`${config.Backend_URL}/abstract`, payload);
    return response;
  };
  static getAllUsers = async () => {
    let payload = {action: "getUniqueAllUsers"};
    const response = await ApiBase.post(`${config.Backend_URL}/search`, payload);
    return response;
  };
  static getActiveInactiveUsers = async () => {
    let payload = {action: "getAllUsers"};
    const response = await ApiBase.post(`${config.Backend_URL}/search`, payload);
    return response;
  };
}


export default UserApi;
